import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        common: {
            neutral: '#4582B8',
            muted: '#9EA0A4',
            butttonHover: '#4582B8'
        },
        defaultButtonColor: {
            main: "#FFFFFF",
            contrastText: "#000000"
        },
        primary: {
            contrastText: "#FFFFFF",
            main: "#24B7CC",
            light: "#24B7CC",
            dark: "#0098B0"
        },
        secondary: {
            contrastText: "#FFFFFF",
            main: '#17B499',
            light: "#17B499",
            dark: '#17B499'
        },
        success: {
            contrastText: "#FFFFFF",
            main: '#45B880',
            light: '#F1FAF5',
            dark: '#00783E'
        },
        info: {
            contrastText: "#FFFFFF",
            main: '#1070CA',
            light: '#F1FBFC',
            dark: '#007489'
        },
        warning: {
            contrastText: "#FFFFFF",
            main: '#FFB822',
            light: '#FDF8F3',
            dark: '#95591E'
        },
        danger: {
            contrastText: "#FFFFFF",
            main: '#ED4740',
            light: '#FEF6F6',
            dark: '#BF0E08'
        },
        text: {
            primary: '#12161B',
            secondary: '#66788A',
            disabled: '#A6B1BB'
        },
        background: {
            default: '#f8fafc',
            dark: '#172B4D',
            paper: "#FFFFFF"
        },
        table: {
            main: 'rgb(105, 104, 117)',
            tableHeadingText: '#FFFFFF',
            headBorder: "1px solid rgb(238, 238, 238)",
            oddRow: "#FFFFFF",
            evenRow: "rgb(238, 238, 238)",
            bodyBorder: " 1px solid rgb(206, 206, 206)",
            rowHover: "#e8e3e3"
        },
        formElement: {
            text: "#3276B1",
            inActive: "#A0A2A7",
            active: "#946a73"
        },
        selectionCriteria: {
            bottom: {
                backgroundImage: "linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 50%, rgba(255,255,255,0) 100%), linear-gradient(-135deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 50%, rgba(255,255,255,0) 100%)",
                backgroundPosition: " top center, top center,  bottom center, bottom center,  top center,  bottom center",
                backgroundSize: " 0.75rem 0.75rem, 0.75rem 0.75rem, 0.75rem 0.75rem, 0.75rem 0.75rem,  100% 1rem, 100% 1rem",
                backgroundRepeat: "repeat-x",
            }
        },
        border: '#DFE3E8',
        divider: '#DFE3E8'
    }
});

export default theme;